import {Record, List} from 'immutable';
import {handleActions} from 'redux-actions';

import * as Actions from './actions';

const DiscountGroupState = Record({
    sessionVersions: List(),
    deletingGroup: false,
    showDeleteGroupForm: false,
    deleteGroup: null,
    deleteIndex: null,
    groupToDelete: null,
    loadingGroups: false,
    hasLoadedGroups: false,
});

export default handleActions(
    {
        [Actions.reset.type]: () => new DiscountGroupState(),
        [Actions.fetchAllSessions.type]: state =>
            state.merge({
                sessionVersions: List(),
                loadingGroups: true,
            }),
        [Actions.showRemoveGroupFromForm.type]: (state, {payload}) =>
            state.merge({
                showDeleteGroupForm: payload.show,
                deleteGroup: payload.group,
                deleteIndex: payload.index,
                groupToDelete: payload.groupToDelete,
            }),
        [Actions.removeGroupFromForm.type]: state =>
            state.merge({
                deletingGroup: true,
            }),
        [Actions.removeGroupFromFormAborted.type]: state =>
            state.merge({
                deletingGroup: false,
            }),
        [Actions.fetchAllSessionsSuccess.type]: (state, {payload}) =>
            state.merge({
                sessionVersions: List(payload.sessionVersions),
                loadingGroups: false,
                hasLoadedGroups: true,
            }),
        [Actions.updateSessionDiscountVolumeGroups.type]: state =>
            state.merge({
                loadingGroups: true,
            }),
        [Actions.updateSessionDiscountVolumeGroupsSuccess.type]: state =>
            state.merge({
                deletingGroup: false,
                loadingGroups: false,
                showDeleteGroupForm: false,
                deleteGroup: null,
                deleteIndex: null,
                groupToDelete: null,
            }),
        [Actions.updateSessionDiscountVolumeGroupsAborted.type]: state =>
            state.merge({
                deletingGroup: false,
                loadingGroups: false,
            }),
        [Actions.updateSessionDiscountVolumeGroupsFailed.type]: state =>
            state.merge({
                deletingGroup: false,
                loadingGroups: false,
            }),
    },
    new DiscountGroupState(),
);
